import { axiosAjax } from '@app/src/config/axios';
import { JobModel } from '@app/src/views/StepOne/form/models/job';

export const jobService = {
  async get(jobName: string): Promise<JobModel[]> {
    try {
      const { data } = await axiosAjax.get(process.env.API_JOB.replace(':jobName', jobName));
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      throw new Error(e);
    }
  }
}